export default __webpack_public_path__ + "static/media/28.6e3f966e.png";